import { createRouter, createWebHistory } from "vue-router";
import Signin from "../views/public/Signin.vue";
import Signup from "../views/public/Signup.vue";
import ForgotPassword from "../views/public/ForgotPassword.vue";
import PasswordReset from "../views/public/PasswordReset.vue";

import store from "../store";
import AnalyticsGeneral from "@/views/analytics/General.vue";
import AnalyticsRetail from "@/views/analytics/Retail.vue";
import ProductList from "@/views/products/list/ProductList.vue";
import LeadsList from "@/views/leads/LeadsList.vue";
import ClaimsList from "@/views/claims/ClaimsList.vue";
import ClaimDetails from "@/views/claims/ClaimDetails";
import UpdateClaimDeclaration from "@/views/claims/UpdateClaimDeclaration.vue";
import PlanSales from "../views/plan_sales/PlanSales.vue";
import DiscountList from "@/views/discounts/DiscountList.vue";
import Challenges from "@/views/challenges/Challenges.vue";
import ChallengeDetails from "@/views/challenges/ChallengeDetails.vue";
import Report from "@/views/report/Report.vue";
import PlanSaleDetails from "@/views/plan_sales/PlanSaleDetails.vue";
import ProductDetails from "@/views/products/details/ProductDetails.vue";
import StoreDetails from "@/views/stores/StoreDetails.vue";
import Organizations from "@/views/organizations/Organizations.vue";
import Stores from "@/views/stores/Stores.vue";
import OrganizationDetails from "@/views/organizations/OrganizationDetails.vue";
import { NotFound } from "@estaly/ui";
import OnboardingsDashboard from "@/views/onboardings/OnboardingsDashboard.vue";
import Invoices from "@/views/billing/Invoices.vue";
import ClaimInvoices from "@/views/billing/ClaimInvoices.vue";
import ContractDistributions from "@/views/contract_distributions/ContractDistributions.vue";
import ContractDistributionDetails from "@/views/contract_distributions/ContractDistributionDetails.vue";
import MerchantProfilesIndex from "@/views/merchant_profiles/MerchantProfilesIndex.vue";
import MerchantProfileDetails from "@/views/merchant_profiles/MerchantProfileDetails.vue";
import UnfixeableClaimProductsList from "@/views/claims/UnfixeableClaimProductsList.vue";
import UnfixeableClaimProductDetails from "@/views/claims/UnfixeableClaimProductDetails.vue";
import ComplaintsList from "@/views/complaints/ComplaintsList.vue";
import EmailLogsList from "@/views/email_logs/EmailLogsList.vue";
import ComplaintDetails from "@/views/complaints/ComplaintDetails.vue";
import BillingEntityDetails from "@/views/billing_entities/BillingEntityDetails.vue";

const routes = [
  {
    path: "/signin",
    component: Signin,
  },
  {
    path: "/signup",
    component: Signup,
  },
  {
    path: "/forgot-password",
    component: ForgotPassword,
  },
  {
    path: "/password-reset/:id",
    component: PasswordReset,
  },
  {
    path: "/",
    component: AnalyticsGeneral,
    meta: { layout: "backoffice-layout" },
  },
  {
    path: "/analytics/general",
    component: AnalyticsGeneral,
    meta: { layout: "backoffice-layout" },
  },
  {
    path: "/analytics/retail",
    component: AnalyticsRetail,
    meta: { layout: "backoffice-layout" },
  },
  {
    path: "/contract-distributions",
    component: ContractDistributions,
    meta: { layout: "backoffice-layout" },
  },
  {
    path: "/contract-distributions/:id",
    component: ContractDistributionDetails,
    meta: { layout: "backoffice-layout" },
  },
  {
    path: "/products",
    component: ProductList,
    meta: { layout: "backoffice-layout" },
  },
  {
    path: "/products/:id",
    component: ProductDetails,
    meta: { layout: "backoffice-layout" },
  },
  {
    path: "/leads",
    component: LeadsList,
    meta: { layout: "backoffice-layout" },
  },
  {
    path: "/claims",
    component: ClaimsList,
    meta: { layout: "backoffice-layout" },
  },
  {
    path: "/claims/mine",
    component: ClaimsList,
    props: { routeAssignee: "me" },
    meta: { layout: "backoffice-layout" },
  },
  {
    path: "/claims/unassigned",
    component: ClaimsList,
    props: { routeAssignee: "unassigned" },
    meta: { layout: "backoffice-layout" },
  },
  {
    path: "/claims/:id",
    component: ClaimDetails,
    meta: { layout: "backoffice-layout" },
  },
  {
    path: "/claims/:id/update-declaration",
    component: UpdateClaimDeclaration,
    meta: { layout: "backoffice-layout" },
  },
  {
    path: "/unfixeable-claim-products",
    component: UnfixeableClaimProductsList,
    meta: { layout: "backoffice-layout" },
  },
  {
    path: "/unfixeable-claim-products/:id",
    component: UnfixeableClaimProductDetails,
    meta: { layout: "backoffice-layout" },
  },
  {
    path: "/plan-sales",
    component: PlanSales,
    meta: { layout: "backoffice-layout" },
  },
  {
    path: "/plan-sales/:id",
    component: PlanSaleDetails,
    meta: { layout: "backoffice-layout" },
  },
  {
    path: "/discounts",
    component: DiscountList,
    meta: { layout: "backoffice-layout" },
  },
  {
    path: "/challenges",
    component: Challenges,
    meta: { layout: "backoffice-layout" },
  },
  {
    path: "/challenges_progress", // TODO: to remove white `/challenges/:id`
    component: ChallengeDetails,
    meta: { layout: "backoffice-layout" },
  },
  {
    path: "/report",
    component: Report,
    meta: { layout: "backoffice-layout" },
  },
  {
    path: "/organizations",
    component: Organizations,
    meta: { layout: "backoffice-layout" },
  },
  {
    path: "/stores",
    component: Stores,
    meta: { layout: "backoffice-layout" },
  },
  {
    path: "/merchant_profiles",
    component: MerchantProfilesIndex,
    meta: { layout: "backoffice-layout" },
  },
  {
    path: "/merchant_profiles/:id",
    component: MerchantProfileDetails,
    meta: { layout: "backoffice-layout" },
  },
  {
    path: "/stores/:id",
    component: StoreDetails,
    meta: { layout: "backoffice-layout" },
  },
  {
    path: "/organizations/:id",
    component: OrganizationDetails,
    meta: { layout: "backoffice-layout" },
  },
  {
    path: "/billing-entities/:id",
    component: BillingEntityDetails,
    meta: { layout: "backoffice-layout" },
  },
  {
    path: "/billing/invoices",
    component: Invoices,
    meta: { layout: "backoffice-layout" },
  },
  {
    path: "/billing/claim_invoices",
    component: ClaimInvoices,
    meta: { layout: "backoffice-layout" },
  },
  {
    path: "/onboardings",
    component: OnboardingsDashboard,
    meta: { layout: "backoffice-layout" },
  },
  {
    path: "/complaints",
    component: ComplaintsList,
    meta: { layout: "backoffice-layout" },
  },
  {
    path: "/email-logs",
    component: EmailLogsList,
    meta: { layout: "backoffice-layout" },
  },
  {
    path: "/complaints/:id",
    component: ComplaintDetails,
    meta: { layout: "backoffice-layout" },
  },
  {
    path: "/404",
    component: NotFound,
  },
];

function needsHttpsRedirection() {
  return (
    (process.env.NODE_ENV === "production" || process.env.NODE_ENV === "demo" || process.env.NODE_ENV === "staging") &&
    location.protocol !== "https:"
  );
}

function redirectHttps() {
  location.replace(`https:${location.href.substring(location.protocol.length)}`);
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  if (needsHttpsRedirection()) {
    redirectHttps();
  } else {
    const publicPages = ["/signin", "/signup", "/forgot-password", "/password-reset/:id"];
    const authRequired = !to.matched.some((matched) => publicPages.includes(matched.path));
    const signedIn = store.state.auth.signedIn;

    // remove IsLoading
    store.state.backoffice.isLoading = false;

    if (authRequired && !signedIn) {
      next("/signin");
    } else if (signedIn) {
      store.dispatch("cable/connect");
      if (to.path === "/") {
        if (store.getters["auth/isEstalyManager"]) {
          next();
        } else {
          next("/signin");
        }
      } else {
        if (to.path === "/signup" || to.path === "signin") {
          next("/");
        } else {
          if (!to.matched.length) {
            next("/404");
          } else {
            next();
          }
        }
      }
    } else {
      next();
    }
  }
});

router;

export default router;
